<template>
    <b-modal id="gerarRtaModal" title="Gerar RTA - Gatilhos Selecionados" size="xl" hide-footer>
        <p class="mb-3">
            <strong>{{ selectedTriggers.length }}</strong> gatilho(s) selecionado(s)
            <span v-if="selectedTriggers.length > 1" class="orange">
                - Selecione o gatilho principal
            </span>
        </p>

        <div class="table-container">
            <b-table
                v-if="selectedTriggers.length > 0"
                :items="selectedTriggers"
                :fields="modalTableFields"
                striped
                hover
                responsive
                small
                class="modal-table">

                <template #cell(principal)="row" v-if="selectedTriggers.length > 1">
                    <b-form-radio
                        v-model="mainTriggerId"
                        :value="row.item.id"
                        name="principal-trigger">
                    </b-form-radio>
                </template>
            </b-table>
        </div>

        <p class="orange mt-3">Confirme se as ocorrências secundárias estão corretas antes de continuar.</p>

        <div class="mt-3 d-flex justify-content-between">
            <b-button variant="secondary" @click="cancelar">
                Cancelar
            </b-button>
            <b-button class="orange-btn" @click="confirmar">
                Confirmar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "GerarRtaModal",
    props: {
        selectedTriggers: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            mainTriggerId: null
        };
    },
    computed: {
        modalTableFields() {
            const baseFields = [
                { key: 'id', label: 'ID', sortable: true, thStyle: { width: '5%' } },
                { key: 'creationDate', label: 'Data do Disparo', sortable: true, thStyle: { width: '10%' } },
                { key: 'indicator', label: 'Indicador', sortable: true, thStyle: { width: '10%' } },
                { key: 'process', label: 'Processo', sortable: true, thStyle: { width: '10%' } },
                { key: 'workshift', label: 'Turno', sortable: true, thStyle: { width: '8%' } },
                { key: 'trigger', label: 'Gatilho', sortable: true, thStyle: { width: '10%' } },
                { key: 'responsible', label: 'Responsável', sortable: true, thStyle: { width: '10%' } },
                { key: 'lowerLimitValue', label: 'Limite Inferior', sortable: true, thStyle: { width: '8%' } },
                { key: 'upperLimitValue', label: 'Limite Superior', sortable: true, thStyle: { width: '8%' } },
                { key: 'prevValue', label: 'Valor Previsto', sortable: true, thStyle: { width: '8%' } },
                { key: 'realValue', label: 'Valor Real', sortable: true, thStyle: { width: '8%' } },
                { key: 'record', label: 'Registro', sortable: true, thStyle: { width: '8%' } },
            ];

            if (this.selectedTriggers.length > 1) {
                return [
                    { key: 'principal', label: 'Principal', thClass: 'text-center', tdClass: 'text-center', thStyle: { width: '5%' } },
                    ...baseFields
                ];
            }

            return baseFields;
        }
    },
    watch: {
        selectedTriggers: {
            handler(newVal) {
                if (newVal.length === 1) {
                    this.mainTriggerId = newVal[0].id;
                } else {
                    this.mainTriggerId = null;
                }
            },
            immediate: true
        }
    },
    methods: {
        cancelar() {
            this.mainTriggerId = null;
            this.$bvModal.hide('gerarRtaModal');
            this.$emit('cancelar');
        },
        confirmar() {
            this.$emit('confirmar', this.mainTriggerId);
        }
    }
};
</script>

<style scoped>
.table-container {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
}

.modal-table {
    font-size: 0.85rem;
}

::v-deep(.modal-table thead th) {
    background-color: #004747;
    color: #fff;
    font-weight: 600;
}

.modal-table tbody td {
    padding: 0.4rem;
    vertical-align: middle;
}

.modal-table tbody tr:hover {
    background-color: #f0f8f8;
}

.orange {
    color: #ff5f00;
    font-weight: 500;
}

::v-deep(.custom-control-input:checked ~ .custom-control-label::after) {
    background-color: #ff5f00;
    border-radius: 100%;
}


::v-deep(.custom-control-input:focus ~ .custom-control-label::before) {
    box-shadow: 0 0 0 0.2rem rgba(255, 95, 0, 0.35);
    border-color: #ff5f00;
}


.orange-btn{
    background-color: #ff5f00;
    border-color: #ff5f00;
    color: #fff;
}
</style>
